import { Ingredient } from '../data';

export function FormattedIngredient(props: Ingredient) {
    return (
        <>
            {props.amount} {props.measurement} {props.name}
            {!!props.meta && ` (${props.meta})`}
        </>
    );
}
